"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { money, walletFromCents } from "@/lib/catalog/logic";
import { useCovet } from "@/components/providers/CovetProvider";
import { useFlows } from "@/components/flows/useFlows";
import { useAuth } from "@/components/providers/AuthProvider";

const NAV: [string, string, string[]][] = [
  ["/", "Home", ["/"]],
  ["/boxes", "Boxes", ["/boxes"]],
  ["/wishlist", "Wishlist", ["/wishlist"]],
  ["/shelf", "My Shelf", ["/shelf"]],
  ["/creators", "Creators", ["/creators"]],
  ["/profile", "Profile", ["/profile"]],
];

export function Header() {
  const path = usePathname() || "/";
  const { state } = useCovet();
  const auth = useAuth();
  /* top-right balance: the account's wallet (GET /api/users/me) when
     signed in, in whole dollars; the prototype's demo balance otherwise */
  const signedIn = auth.status === "signedIn";
  const balance = signedIn
    ? (auth.user?.wallet ? walletFromCents(auth.user.wallet.totalCents) : "…")
    : money(state.wallet);
  const f = useFlows();
  const active = (prefixes: string[]) => prefixes.some((p) => (p === "/" ? path === "/" : path === p || path.startsWith(p + "/")));
  return (
    <header className="site-head">
      <div className="shell">
        <Link className="wordmark" href="/">Cov<span>et</span></Link>
        <nav className="site-nav" aria-label="Main">
          {NAV.map(([href, label, pre]) => (
            <Link key={href} href={href} className={active(pre) ? "active" : undefined}>{label}</Link>
          ))}
        </nav>
        {!state.signedIn && auth.status === "signedOut" && <button className="head-auth" onClick={() => f.openAuth("in")}>Sign in</button>}
        <div className="wallet-chip">
          <button className="wc-bal" onClick={() => f.openWallet()} aria-label={`Wallet balance ${balance}`}><span data-wallet>{balance}</span></button>
          <button className="wc-add" onClick={() => f.openAddFunds()} aria-label="Add funds">+</button>
        </div>
      </div>
    </header>
  );
}
